import { render, staticRenderFns } from "./forgot_password_init.vue?vue&type=template&id=b19e4632&"
import script from "./forgot_password_init.vue?vue&type=script&lang=js&"
export * from "./forgot_password_init.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports